import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class OAuthService {
  constructor(
    private router: Router, 
    private http: HttpClient
  ){}
 
  private formatErrors(error: any) {
    return  throwError(error.error);
  }

  obtainAccessToken(username: any, password: any, grant_type: any): Observable <any>{
    let params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);    
    params.append('grant_type', grant_type);

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8', 
        'Authorization': 'Basic '+btoa("trusted-app:spring-security-oauth2-read-write-client-password1234")
      })
    };
    return this.http.post(
      'http://localhost:8888/oauth/token', 
      params.toString(), 
      httpOptions
    ).pipe(catchError(this.formatErrors));
  }
}